import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import TextInput from "atoms/forms/text-input";
import Icon from "atoms/icons/icon";
import React from "react";
import { useBookviewSearchContext } from "utilities/contexts/bookview-tab-panel/bookview-search-provider";
import { useBookviewTabPanel } from "utilities/contexts/bookview-tab-panel/use-bookview-tab-panel";
import useBreakpointRanges from "utilities/hooks/use-breakpoint-ranges";
import { t } from "utilities/localization-utils";
const BASE_CLASS = "c-bookview-search-bar";
interface BookviewSearchbarProps {
    isLegacyPublicationView?: boolean;
}
const BookviewSearchbar = ({
    isLegacyPublicationView,
}: BookviewSearchbarProps) => {
    const { toggleBookviewSearchPanel } = useBookviewTabPanel();
    const { inMobileView } = useBreakpointRanges();

    const {
        handleTextChange,
        searchInputRef,
        setIsSearchActive,
        isSearchActive,
        draftSearchText,
        setDraftSearchText,
        search,
        searchText,
        isDisabled,
    } = useBookviewSearchContext();

    const handleSearchClick = () => {
        if (!inMobileView) {
            toggleBookviewSearchPanel();
        }
        draftSearchText === searchText
            ? search() // Force a refresh of search
            : handleTextChange(draftSearchText);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSearchClick();
        }
    };

    const handleDraftTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDraftSearchText(e.currentTarget.value);
    };

    return (
        <div className={BASE_CLASS}>
            {!inMobileView && !isLegacyPublicationView && (
                <Button
                    cssClassName={`collapse-button${isSearchActive ? " -expanded" : ""}`}
                    accessibleText={`${t("collapse")}`}
                    style={ButtonStyles.None}
                    onClick={() => {
                        setIsSearchActive(false);
                    }}
                    data-test-id={"close-button"}>
                    <Icon type={Icons.ChevronRight} size={IconSizes.Base} />
                </Button>
            )}
            <TextInput
                cssClassName={`${BASE_CLASS}__input`}
                id={t("search")}
                onChange={handleDraftTextChange}
                onKeyDown={handleKeyDown}
                value={draftSearchText}
                ref={searchInputRef}
                placeholder={t("find")}
                onFocus={() => setIsSearchActive(true)}
                disabled={isDisabled}
                ariaLabel={t("search-this-publication")}
            />
            <Button
                cssClassName={`${BASE_CLASS}__button`}
                size={ButtonSizes.XSmall}
                style={ButtonStyles.Primary}
                onClick={handleSearchClick}
                disabled={isDisabled}
                ariaLabel={t("search")}>
                <Icon
                    cssClassName={"-search-icon"}
                    size={IconSizes.Medium}
                    type={Icons.Search}
                />
            </Button>
        </div>
    );
};

export default BookviewSearchbar;
